import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkPredictSurfaceTreatment = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkPredictSurfaceTreatment
>;

export type BulkPredictSurfaceTreatmentDto = ClientInferRequest<
  typeof contract.quoteRequestLines.bulkPredictSurfaceTreatment
>["body"];

export const bulkPredictSurfaceTreatment = async (
  payload: BulkPredictSurfaceTreatmentDto,
): Promise<BulkPredictSurfaceTreatment> => {
  const response = await api.quoteRequestLines.bulkPredictSurfaceTreatment.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to predict surface treatment by bulk", response.status, response.body);
};
